"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declinePortalEstimateRequestSchema = exports.acceptPortalEstimateRequestSchema = exports.portalInvoiceDetailSchema = exports.portalInvoiceListResponseSchema = exports.portalInvoiceSummarySchema = exports.portalInvoiceLineSchema = exports.portalInvoiceServiceLocationSchema = exports.portalInvoicePaymentSummarySchema = exports.portalInvoiceFinancialStatusSchema = exports.portalEstimateDetailSchema = exports.portalEstimateListResponseSchema = exports.portalEstimateSummarySchema = exports.portalEstimateGroupSchema = exports.portalSessionSchema = exports.portalMagicLinkExchangeResponseSchema = exports.exchangePortalMagicLinkRequestSchema = exports.portalMagicLinkRequestedResponseSchema = exports.requestPortalMagicLinkSchema = exports.portalPublicBusinessSchema = exports.portalCustomerAccessSchema = exports.portalInvitationSchema = exports.sendPortalInvitationRequestSchema = exports.portalInvitationStatusSchema = exports.portalSettingsResponseSchema = exports.portalSettingsSchema = exports.portalBusinessProfileSchema = exports.updatePortalSettingsRequestSchema = exports.portalAccentColorSchema = exports.portalSlugSchema = exports.PORTAL_RESERVED_SLUGS = exports.PORTAL_SIGNATURE_CONSENT_TEXT = exports.PORTAL_SIGNATURE_CONSENT_VERSION = void 0;
const zod_1 = require("zod");
const estimate_1 = require("./estimate");
const invoice_1 = require("./invoice");
const payment_processing_1 = require("./payment-processing");
exports.PORTAL_SIGNATURE_CONSENT_VERSION = "estimate-electronic-signature-v1";
exports.PORTAL_SIGNATURE_CONSENT_TEXT = "I agree to use my typed name as my electronic signature and accept this exact estimate version.";
exports.PORTAL_RESERVED_SLUGS = [
    "access",
    "admin",
    "api",
    "app",
    "auth",
    "billing",
    "crewfsm",
    "help",
    "login",
    "logout",
    "settings",
    "support",
    "www",
];
exports.portalSlugSchema = zod_1.z
    .string()
    .trim()
    .toLowerCase()
    .min(3)
    .max(48)
    .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/, "Use lowercase letters, numbers, and single hyphens.")
    .refine((value) => !value.includes("--"), {
    message: "Consecutive hyphens are not allowed.",
})
    .refine((value) => !exports.PORTAL_RESERVED_SLUGS.includes(value), { message: "This portal address is reserved." });
exports.portalAccentColorSchema = zod_1.z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^#[0-9A-F]{6}$/, "Use a six-digit hex color.");
const optionalEmail = zod_1.z
    .union([zod_1.z.string().trim().email().max(320), zod_1.z.literal(""), zod_1.z.null()])
    .optional()
    .transform((value) => (value === undefined ? undefined : value || null));
const optionalPhone = zod_1.z
    .union([
    zod_1.z
        .string()
        .trim()
        .regex(/^\+[1-9]\d{7,14}$/, "Phone must use E.164 format."),
    zod_1.z.literal(""),
    zod_1.z.null(),
])
    .optional()
    .transform((value) => (value === undefined ? undefined : value || null));
exports.updatePortalSettingsRequestSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    slug: exports.portalSlugSchema,
    displayName: zod_1.z.string().trim().min(2).max(120),
    primaryAccentColor: exports.portalAccentColorSchema,
    welcomeMessage: zod_1.z.string().trim().min(1).max(500),
    supportEmail: optionalEmail,
    supportPhone: optionalPhone,
    includeEstimatePortalLink: zod_1.z.boolean(),
    autoInviteOnEstimateSend: zod_1.z.boolean(),
    termsAndConditions: zod_1.z.string().trim().min(1).max(10_000),
});
exports.portalBusinessProfileSchema = zod_1.z.object({
    name: zod_1.z.string(),
    logoUrl: zod_1.z.string().url().nullable(),
    contactEmail: zod_1.z.string().email().nullable(),
    phone: zod_1.z.string().nullable(),
    address: zod_1.z.object({
        name: zod_1.z.string(),
        addressLine1: zod_1.z.string(),
        addressLine2: zod_1.z.string().nullable(),
        city: zod_1.z.string(),
        state: zod_1.z.string().length(2),
        postalCode: zod_1.z.string(),
        country: zod_1.z.literal("US"),
    }),
});
exports.portalSettingsSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    slug: exports.portalSlugSchema,
    displayName: zod_1.z.string(),
    primaryAccentColor: exports.portalAccentColorSchema,
    welcomeMessage: zod_1.z.string(),
    supportEmail: zod_1.z.string().email().nullable(),
    supportPhone: zod_1.z.string().nullable(),
    includeEstimatePortalLink: zod_1.z.boolean(),
    autoInviteOnEstimateSend: zod_1.z.boolean(),
    termsAndConditions: zod_1.z.string(),
    portalUrl: zod_1.z.string().url(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.portalSettingsResponseSchema = zod_1.z.object({
    settings: exports.portalSettingsSchema,
    businessProfile: exports.portalBusinessProfileSchema,
    canManage: zod_1.z.boolean(),
});
exports.portalInvitationStatusSchema = zod_1.z.enum([
    "QUEUED",
    "SENT",
    "FAILED",
    "USED",
    "EXPIRED",
    "REVOKED",
]);
exports.sendPortalInvitationRequestSchema = zod_1.z.object({
    contactId: zod_1.z.string().uuid(),
    estimateId: zod_1.z.string().uuid().optional(),
});
exports.portalInvitationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    contactId: zod_1.z.string().uuid(),
    contactName: zod_1.z.string(),
    contactEmail: zod_1.z.string().email(),
    status: exports.portalInvitationStatusSchema,
    targetEstimateId: zod_1.z.string().uuid().nullable(),
    queuedAt: zod_1.z.string().datetime(),
    sentAt: zod_1.z.string().datetime().nullable(),
    expiresAt: zod_1.z.string().datetime(),
    failureReason: zod_1.z.string().nullable(),
});
exports.portalCustomerAccessSchema = zod_1.z.object({
    customerId: zod_1.z.string().uuid(),
    status: zod_1.z.enum(["NOT_GRANTED", "ACTIVE", "REVOKED"]),
    contactId: zod_1.z.string().uuid().nullable(),
    grantedAt: zod_1.z.string().datetime().nullable(),
    revokedAt: zod_1.z.string().datetime().nullable(),
    lastAccessedAt: zod_1.z.string().datetime().nullable(),
    invitations: zod_1.z.array(exports.portalInvitationSchema),
});
exports.portalPublicBusinessSchema = zod_1.z.object({
    canonicalSlug: exports.portalSlugSchema,
    requestedSlug: exports.portalSlugSchema,
    redirectRequired: zod_1.z.boolean(),
    displayName: zod_1.z.string(),
    primaryAccentColor: exports.portalAccentColorSchema,
    welcomeMessage: zod_1.z.string(),
    supportEmail: zod_1.z.string().email().nullable(),
    supportPhone: zod_1.z.string().nullable(),
    businessProfile: exports.portalBusinessProfileSchema,
});
exports.requestPortalMagicLinkSchema = zod_1.z.object({
    email: zod_1.z.string().trim().toLowerCase().email().max(320),
});
exports.portalMagicLinkRequestedResponseSchema = zod_1.z.object({
    message: zod_1.z.literal("If this email exists in the business records, a sign-in link has been sent."),
});
exports.exchangePortalMagicLinkRequestSchema = zod_1.z.object({
    token: zod_1.z.string().min(64).max(512),
});
exports.portalMagicLinkExchangeResponseSchema = zod_1.z.object({
    sessionToken: zod_1.z.string().min(32),
    expiresAt: zod_1.z.string().datetime(),
    businessSlug: exports.portalSlugSchema,
    redirectPath: zod_1.z.string().startsWith("/b/"),
});
exports.portalSessionSchema = zod_1.z.object({
    businessSlug: exports.portalSlugSchema,
    customer: zod_1.z.object({ id: zod_1.z.string().uuid(), displayName: zod_1.z.string() }),
    contact: zod_1.z.object({ id: zod_1.z.string().uuid(), name: zod_1.z.string() }),
    brand: exports.portalPublicBusinessSchema.omit({
        requestedSlug: true,
        redirectRequired: true,
    }),
    expiresAt: zod_1.z.string().datetime(),
});
exports.portalEstimateGroupSchema = zod_1.z.enum([
    "OPEN",
    "ACCEPTED",
    "DECLINED",
    "EXPIRED",
]);
exports.portalEstimateSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    estimateNumber: zod_1.z.number().int().positive(),
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    group: exports.portalEstimateGroupSchema,
    totalCents: zod_1.z.number().int().nonnegative(),
    serviceLocationName: zod_1.z.string(),
    issuedAt: zod_1.z.string().datetime(),
    expiresAt: zod_1.z.string().datetime().nullable(),
    decidedAt: zod_1.z.string().datetime().nullable(),
});
exports.portalEstimateListResponseSchema = zod_1.z.object({
    groups: zod_1.z.object({
        open: zod_1.z.array(exports.portalEstimateSummarySchema),
        accepted: zod_1.z.array(exports.portalEstimateSummarySchema),
        declined: zod_1.z.array(exports.portalEstimateSummarySchema),
        expired: zod_1.z.array(exports.portalEstimateSummarySchema),
    }),
});
exports.portalEstimateDetailSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    contentHash: zod_1.z.string().length(64),
    group: exports.portalEstimateGroupSchema,
    state: zod_1.z.enum(["OPEN", "ACCEPTED", "DECLINED", "EXPIRED", "SUPERSEDED"]),
    document: estimate_1.estimateVersionDocumentSchema,
    viewedAt: zod_1.z.string().datetime().nullable(),
    decidedAt: zod_1.z.string().datetime().nullable(),
    signature: zod_1.z
        .object({
        signerName: zod_1.z.string(),
        signedAt: zod_1.z.string().datetime(),
        consentText: zod_1.z.string(),
        consentVersion: zod_1.z.string(),
    })
        .nullable(),
});
exports.portalInvoiceFinancialStatusSchema = invoice_1.invoiceFinancialStatusSchema;
exports.portalInvoicePaymentSummarySchema = zod_1.z.object({
    amountCents: zod_1.z.number().int().positive(),
    method: invoice_1.paymentMethodSchema,
    receivedAt: zod_1.z.string().datetime(),
    status: zod_1.z.enum(["APPLIED", "REVERSED"]),
    reversedAt: zod_1.z.string().datetime().nullable(),
});
exports.portalInvoiceServiceLocationSchema = zod_1.z.object({
    name: zod_1.z.string(),
    addressLine1: zod_1.z.string(),
    addressLine2: zod_1.z.string().nullable(),
    city: zod_1.z.string(),
    state: zod_1.z.string().length(2),
    postalCode: zod_1.z.string(),
});
exports.portalInvoiceLineSchema = zod_1.z.object({
    position: zod_1.z.number().int().nonnegative(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    pricingUnit: zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]),
    quantityMilli: zod_1.z.number().int().positive(),
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    taxable: zod_1.z.boolean(),
    lineTotalCents: zod_1.z.number().int().nonnegative(),
});
exports.portalInvoiceSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    invoiceNumber: zod_1.z.number().int().positive(),
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    contentHash: zod_1.z.string().length(64),
    financialStatus: exports.portalInvoiceFinancialStatusSchema,
    totalCents: zod_1.z.number().int().nonnegative(),
    amountPaidCents: zod_1.z.number().int().nonnegative(),
    balanceCents: zod_1.z.number().int().nonnegative(),
    serviceLocation: exports.portalInvoiceServiceLocationSchema,
    issuedAt: zod_1.z.string().datetime(),
    dueAt: zod_1.z.string().datetime(),
});
exports.portalInvoiceListResponseSchema = zod_1.z.object({
    groups: zod_1.z.object({
        outstanding: zod_1.z.array(exports.portalInvoiceSummarySchema),
        paid: zod_1.z.array(exports.portalInvoiceSummarySchema),
    }),
});
exports.portalInvoiceDetailSchema = exports.portalInvoiceSummarySchema.extend({
    job: zod_1.z.object({
        jobNumber: zod_1.z.number().int().positive(),
        summary: zod_1.z.string(),
    }),
    recipientName: zod_1.z.string(),
    paymentTerms: invoice_1.invoicePaymentTermsSchema,
    notes: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.portalInvoiceLineSchema),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxRateMilliPercent: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    payments: zod_1.z.array(exports.portalInvoicePaymentSummarySchema),
    onlinePayment: payment_processing_1.portalOnlinePaymentSchema,
    viewedAt: zod_1.z.string().datetime().nullable(),
});
exports.acceptPortalEstimateRequestSchema = zod_1.z.object({
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    signerName: zod_1.z.string().trim().min(2).max(160),
    consentAccepted: zod_1.z.literal(true),
    consentVersion: zod_1.z.literal(exports.PORTAL_SIGNATURE_CONSENT_VERSION),
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.declinePortalEstimateRequestSchema = zod_1.z.object({
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    idempotencyKey: zod_1.z.string().uuid(),
    reason: zod_1.z
        .string()
        .trim()
        .max(1_000)
        .optional()
        .transform((value) => value || undefined),
});
//# sourceMappingURL=portal.js.map